'use strict';

class ContactButton {

    constructor() {
        const contactButton = document.querySelector('.contact-button');

        if (contactButton) {
            this.offsetWidth = contactButton.offsetWidth;
            contactButton.classList.add('contact-button--loaded');
            const self = this;

            ['mouseover', 'focus'].forEach(function (event) {
                contactButton.addEventListener(event, function (e) {
                    if (screen.width > 992) {
                        contactButton.style.width = self.offsetWidth + 1 + 'px';
                    }
                });
            });

            ['mouseleave', 'blur'].forEach(function (event) {
                contactButton.addEventListener(event, function (e) {
                    if (document.activeElement !== contactButton) {
                        contactButton.style.width = null;
                    }
                });
            });
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    new ContactButton();
});